const yuCardInfo = () => import("@/pages/yuCard/yuCard/yuCard.vue");
const yuCardBatch = () => import("@/pages/yuCard/yuCardBatch/yuCardBatch.vue");
const yuCardCode = () => import("@/pages/yuCard/yuCardCode/yuCardCode.vue");
export default [
  {
    path: "/yuCard/info",
    name: "yuCardInfo",
    component: yuCardInfo,
    meta: {
      title: "身份码标记",
      noCache: true,
      affix: true,
      path: ["鱼管理", "身份码标记"]
    }
  },
  {
    path: "/yuCard/batch",
    name: "yuCardBatch",
    component: yuCardBatch,
    meta: {
      title: "身份码批次",
      noCache: true,
      affix: true,
      path: ["鱼管理", "身份码批次"]
    },
  },
  {
    path: "/yuCard/code",
    name: "yuCardCode",
    component: yuCardCode,
    meta: {
      title: "身份码验证码",
      noCache: true,
      affix: true,
      path: ["鱼管理", "身份码验证码"]
    },
  }
];



// WEBPACK FOOTER //
// ./src/router/yuCard.js